'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalog = require('./remote/catalog');

var Catalog = {
    fetchCatalogsByIds: _catalog.CatalogRemote.fetchCatalogsByIds,
    fetchCuratorsForCatalog: _catalog.CatalogRemote.fetchCuratorsForCatalog,
    fetchRegisteredCatalogs: _catalog.CatalogRemote.fetchRegisteredCatalogs,
    fetchUpcomingCatalogs: _catalog.CatalogRemote.fetchUpcomingCatalogs,
    postCatalogItems: _catalog.CatalogRemote.postCatalogItems,
    postCatalogItems2: _catalog.CatalogRemote.postCatalogItems2,
    postRegisterForCatalog: _catalog.CatalogRemote.postRegisterForCatalog
};

exports.default = Catalog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalog.js
// module id = bRXb
// module chunks = 60